export default "__VITE_ASSET__BQFFoJcg__"